import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import MainRouter from "./app/MainRouter";

// import './fonts.css';
import "./index.scss";
import { VERSIONS } from "@entities/UpdateComponent/UpdateComponent";

// Add Eruda for AW browser debugging or UnrealEngine
if(
	(import.meta.env.DEV && typeof window.AwApi !== "undefined") ||
	(navigator.userAgent.indexOf("UnrealEngine") !== -1)
) {
	const script1 = document.createElement('script');
	script1.src = "https://cdn.jsdelivr.net/npm/eruda";
	script1.onload = function() {
		const script2 = document.createElement('script');
		script2.textContent = "eruda.init();";
		document.head.appendChild(script2);
	};
	document.head.appendChild(script1);
}
// Это есть только в ноде
console.log("Environment: %o", import.meta.env);
console.log("BASE_URL: %s", import.meta.env.BASE_URL);
console.log(`PublicUrl: ${import.meta.env.PUBLIC_URL}`);
console.log(`url: ${import.meta.env.url}`);
console.log(`BuildId: ${import.meta.env.REACT_APP_BUILD_ID}`);

// +++ START МОКИ!
//
// import { FxApiFileHelper, FxApiHelper } from '@/FxIdApi';
// (window as any).FxApi = new FxApiHelper();
// (window as any).FxApi.File = new FxApiFileHelper();
//
// --- END МОКИ!

if (typeof window.FxApi !== "undefined") {
	console.log(`App version: ${FxApi.getAppVersion()}`);
	if (FxApi.writeLog) {
		const { log } = console;
		console.log = (...args) => {
			log(...args);
			try {
				FxApi.writeLog("info", args.join(" "));
			} catch (e) {
				console.error("Exception in FxApi.writeLog: ", e);
			}
		};
	}
} else {
	new Promise<void>((resolve) => {
		const script = document.createElement("script");
		script.onload = () => resolve();
		script.src = `${import.meta.env.BASE_URL}fxapi_browser.js`;
		document.head.appendChild(script);
	});
}

// Если апи FxApi не доступен то значит мы в браузере
if (typeof window.FxApi === "undefined" || FxApi.getAppVersion() >= VERSIONS.VERSION_WITH_SENTRY_SUPPORT) {
	const sentryUrl =
		import.meta.env.BASE_URL == null ||
		import.meta.env.BASE_URL === "/" ||
		import.meta.env.BASE_URL === "" ||
		import.meta.env.BASE_URL === "./"
			? "/api/s_tunnel"
			: import.meta.env.BASE_URL.startsWith("http")
				? new URL("/api/s_tunnel", import.meta.env.BASE_URL).toString()
				: new URL(
						"/api/s_tunnel",
						new URL(import.meta.env.BASE_URL, window.location.origin).toString()
					).toString();

	// Составное окружение для Sentry: {tenant}-{env}. Та же формула у бэкенда (SentryExtensions.SentryEnv),
	// fxid-web и deploy-записей Jenkins — события одной выкатки фильтруются одним environment
	const sentryTenant = String(import.meta.env.VITE_APP_TENANT_OVERRIDE ?? "default").toLowerCase();
	const sentryEnvRaw = String(import.meta.env.VITE_APP_ENV_OVERRIDE_NAME ?? "");
	const sentryEnvironment = `${sentryTenant}-${sentryEnvRaw}`;

	const sentryInitConfig: Sentry.BrowserOptions = {
		release: import.meta.env.VITE_APP_BUILD_ID,
		environment: sentryEnvironment,
		dsn: "https://14fa75e00995748490fc958a36850855@sentry.fxgam.es/5",
		tunnel: sentryUrl,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: true,
				networkDetailAllowUrls: [
					/^https:\/\/id\.wishlistgames\.net\/.*/,
					/^https:\/\/id-beta\.fxtools\.gl\/*/,
					/^https:\/\/id-dev\.fx\.gl\/*/
				]
			})

			// Sentry.feedbackIntegration({
			//     // Additional SDK configuration goes in here, for example:
			//     colorScheme: 'dark',
			//     showName: false,
			// }),
		],
		// Performance Monitoring
		tracesSampleRate: 0.25, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		// tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
		// Session Replay
		// replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysSessionSampleRate: 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
		initialScope: {
			tags: {
				tenant: sentryTenant,
				env: sentryEnvRaw
			}
		}
	};

	console.log("Initializing sentry with config: %o", sentryInitConfig);

	Sentry.init(sentryInitConfig);
}

ReactDOM.createRoot(document.getElementById("root")!).render(<MainRouter />);
